import React from 'react';

import Header from '../components/Header';

const HeaderEnonic = (props: any) => {
    return <Header {...props} />;
}

export default HeaderEnonic;
